(function() {
  if (customElements.get('zuma-blog-share')) return;

  class BlogShare extends HTMLElement {
    constructor() {
      super();
      this.addEventListener('click', this.handleClick.bind(this));
    }

    setFeedback(message) {
      var feedback = this.querySelector('[data-share-feedback]');
      if (feedback) feedback.textContent = message;
    }

    async copyUrl(url) {
      if (navigator.clipboard && window.isSecureContext) {
        await navigator.clipboard.writeText(url);
        return;
      }

      var previousFocus = document.activeElement;
      var temporaryInput = document.createElement('textarea');
      temporaryInput.value = url;
      temporaryInput.setAttribute('readonly', '');
      temporaryInput.style.cssText = 'position:fixed;top:0;left:0;opacity:0;font-size:16px';
      document.body.appendChild(temporaryInput);

      try {
        temporaryInput.focus({ preventScroll: true });
        temporaryInput.select();
        temporaryInput.setSelectionRange(0, url.length);
        if (!document.execCommand('copy')) throw new Error('Copy command failed');
      } finally {
        temporaryInput.remove();
        if (previousFocus) previousFocus.focus({ preventScroll: true });
      }
    }

    async handleClick(event) {
      var button = event.target.closest('[data-instagram-share]');
      if (!button || !this.contains(button) || button.disabled) return;

      var shareData = {
        title: button.dataset.shareTitle || document.title,
        url: button.dataset.shareUrl
      };

      this.setFeedback('');
      button.disabled = true;

      try {
        try {
          if (navigator.share && (!navigator.canShare || navigator.canShare(shareData))) {
            await navigator.share(shareData);
            this.setFeedback('Share options opened.');
            return;
          }
        } catch (error) {
          if (error.name === 'AbortError') return;
        }

        await this.copyUrl(shareData.url);
        this.setFeedback('Link copied. Open Instagram to share it.');
      } catch (error) {
        this.setFeedback('Unable to copy the link. Please copy it from your browser.');
      } finally {
        button.disabled = false;
      }
    }
  }

  customElements.define('zuma-blog-share', BlogShare);
})();
